'use client';
import dynamic from 'next/dynamic';

const PolicyPDFViewer = dynamic(() => import('@/components/PolicyPDFViewer'), {
  ssr: false,
});

export default function Page() {
  return <PolicyPDFViewer fileUrl="https://triotech-website.famapp.co.in/Fees_and_Charges.pdf" />;
}
